export default function Success() {

  return (
    <div>
      <h2>Form Submission Successful</h2>
      <p>Your form submission was successful!</p>
      <p>Redirecting to the homepage...</p>
    </div>
  );
}